<template>
  <div id="ilogin">
    <div class="main">
      <ul class="nav">
        <li :class="{'active': pwdShow}" @click="showPwd">账号密码登录</li>
        <li :class="{'active': !pwdShow}" @click="showValidate">手机快捷登录</li>
      </ul>
      <ul class="cc" v-if="pwdShow">
        <li class="tel" :class="{active: numberFocusState}">
          <input type="text" name="number" placeholder="请输入您的手机号" required="" v-model="number" @focus="setFocus(1, true)" @blur="setFocus(1, false)">
        </li>
        <li class="newpwd" :class="{active: passwordFocusState}">
          <input type="password" name="password" placeholder="请输入密码" maxlength="18" v-model="password" v-on:keyup.13="postAccount()" @focus="setFocus(2, true)" @blur="setFocus(2, false)">
        </li>
        <li>
          <input type="button" value="登录" v-on:click="postAccount()">
        </li>
      </ul>
      <ul class="cc c2" v-else>
        <li class="tel" :class="{active: phoneFocusState}">
          <input type="text" name="phone" placeholder="请输入您的手机号" required="" v-model="phone" @focus="setFocus(3, true)" @blur="setFocus(3, false)">
        </li>
        <li class="newpwd" :class="{active: codeFocusState}">
          <input type="password" name="password" placeholder="请输入验证码" maxlength="6" v-model.trim="code" v-on:keyup.13="postCodeLogin" @focus="setFocus(4, true)" @blur="setFocus(4, false)">
          <a class="send" v-on:click="sendMsg()" :class="{'disable': countFlag}">{{btnMsg}}</a>
        </li>
        <li>
          <input type="button" value="登录" v-on:click="sendLogin()">
        </li>
      </ul>
      <div class="cue">
        <a href="" v-show="pwdShow" style="visibility: hidden">忘记密码？</a>
      </div>
      <!--第三方登录-->
      <div class="thirdlogin" style="display: none">
        <div class="cc">
          <a href=""><img src="../../../../assets/icon/pwdlogin_icon_wx.png" alt="">微信</a>
          <a href=""><img src="../../../../assets/icon/pwdlogin_icon_qq.png" alt="">QQ</a>
        </div>
      </div>
      <div class="close" @click="hideChoose">&times;</div>
    </div>
    <div class="bg" @click="hideChoose"></div>
  </div>
</template>

<script>
export default {
  name: 'iLogin',
  data () {
    return {
      pwdShow: true,
      phone: '',
      number: this.$store.state.loginname, // 登录账号一般为手机号待定其他类型账号
      password: '', // 登录密码 长度 6 -18 位
      code: '', // 登录验证码
      countNum: 60, // 倒计时周期
      btnMsg: '获取验证码', // 默认按钮显示值
      countFlag: false, // 用于倒计时标记，true - 正在倒计时
      intervalBtn: {}, // 定时器
      numberFocusState: false, // 用户名输入框激活状态
      passwordFocusState: false, // 密码输入框激活状态
      phoneFocusState: false, // 电话输入框激活状态
      codeFocusState: false // 验证码输入框激活状态
    }
  },
  methods: {
    hideChoose () {
      this.$emit('listenShow', false)
    },
    showChoose () {
      this.$emit('listenShow', true)
    },
    showPwd () {
      this.pwdShow = true
    },
    showValidate () {
      this.pwdShow = false
    },
    postAccount () {
      let data = {
        number: this.number,
        password: this.password
      }
      if (!data.number) {
        alert('用户名不能为空')
        return false
      }
      if (!data.password) {
        alert('密码不能为空')
        return false
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_account_login',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$store.dispatch('alterName', res.data.data.name)
            this.$store.dispatch('alterNickname', res.data.data.nickname)
            this.$store.dispatch('alterPeriod', res.data.data.period)
            this.$store.dispatch('alterPortrait', res.data.data.portrait)
            this.$store.dispatch('alterSchool', res.data.data.school_name)
            this.$store.dispatch('alterSubject', res.data.data.subject)
            this.$store.dispatch('alterToken', res.data.data.token)
            this.$store.dispatch('alterUid', res.data.data.uid)
            this.$store.dispatch('alterVipname', res.data.data.vip_name)
            this.$store.dispatch('alterViptime', res.data.data.vip_time)
            console.log(this.$store.state.name)
            console.log(this.$store.state.nickname)
            console.log(this.$store.state.period)
            console.log(this.$store.state.portrait)
            console.log(this.$store.state.school)
            console.log(this.$store.state.subject)
            console.log(this.$store.state.token)
            console.log(this.$store.state.uid)
            console.log(this.$store.state.vipname)
            console.log(this.$store.state.viptime)
            alert('登录成功')
            this.hideChoose()
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getPhoneCode () {
      let data = {
        phone: this.phone,
        type: 2 // 请求类型 注册(1)、登录(2)、找回密码(3)、更换手机号原手机(4)、新手机(5)、微信绑定手机号(6)
      }
      if (!data.phone) {
        alert('手机号不能为空')
        return false
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_phone_code',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            alert('短信验证码已发送，请留意查收！')
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    postCodeLogin () {
      let data = {
        phone: this.phone,
        code: this.code,
        parameter: this.$store.state.activedata
      }
      if (!data.phone) {
        alert('手机号不能为空')
        return false
      }
      if (!data.code) {
        alert('密码不能为空')
        return false
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_code_login',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200 || res.data.errcode === 20002 || res.data.errcode === 20003) {
            this.$store.dispatch('alterName', res.data.data.name)
            this.$store.dispatch('alterNickname', res.data.data.nickname)
            this.$store.dispatch('alterPeriod', res.data.data.period)
            this.$store.dispatch('alterPortrait', res.data.data.portrait)
            this.$store.dispatch('alterSchool', res.data.data.school_name)
            this.$store.dispatch('alterSubject', res.data.data.subject)
            this.$store.dispatch('alterToken', res.data.data.token)
            this.$store.dispatch('alterUid', res.data.data.uid)
            this.$store.dispatch('alterVipname', res.data.data.vip_name)
            this.$store.dispatch('alterViptime', res.data.data.vip_time)
            console.log(this.$store.state.name)
            console.log(this.$store.state.nickname)
            console.log(this.$store.state.period)
            console.log(this.$store.state.portrait)
            console.log(this.$store.state.school)
            console.log(this.$store.state.subject)
            console.log(this.$store.state.token)
            console.log(this.$store.state.uid)
            console.log(this.$store.state.vipname)
            console.log(this.$store.state.viptime)
            alert('登录成功')
            this.hideChoose()
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
      return false
    },
    sendLogin () {
      if (this.pwdShow) {
        this.postAccount()
      } else {
        this.postCodeLogin()
      }
    },
    // 验证是否需要登录弹窗
    validataToken () {
      let data = {
      }
      return this.$axios({
        method: 'GET',
        url: '/api/app/v1/overdue_user_token',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            return true
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 倒计时
    countDown () {
      // this.btnMsg = this.countNum + 's重新发送'
      // 更改btn状态
      this.countFlag = true
      this.intervalBtn = setInterval(() => {
        this.btnMsg = this.countNum + 's重新发送'
        if (this.countNum <= 0) {
          this.btnMsg = '获取验证码'
          // 清除定时器
          clearInterval(this.intervalBtn)
          // 更改btn状态
          this.countFlag = false
          this.countNum = 60
        }
        // 倒计时
        this.countNum--
      }, 1000)
    },
    sendMsg () {
      if (this.countFlag) return false
      if (!this.phone) {
        alert('手机号不能为空')
        return false
      }
      if (!(/^1(3|4|5|6|7|8)\d{9}$/.test(this.phone))) {
        alert('手机号格式错误')
        return
      }
      this.countDown()
      this.getPhoneCode()
    },
    // 设置焦点
    setFocus (Num, bool) {
      if (Num === 1) {
        this.numberFocusState = bool
      } else if (Num === 2) {
        this.passwordFocusState = bool
      } else if (Num === 3) {
        this.phoneFocusState = bool
      } else if (Num === 4) {
        this.codeFocusState = bool
      }
    }
  },
  mounted () {
    // this.validataToken() // 关闭初始化验证
  }
}
</script>

<style scoped lang="stylus">
#ilogin
  .main
    position: fixed
    top: 50%
    left: 50%
    z-index: 1006
    width: 6.7rem
    /*height: 7.56rem*/
    height: 5.56rem
    background-color: #fff
    -webkit-transform: translate(-50%, -50%)
    -moz-transform: translate(-50%, -50%)
    -ms-transform: translate(-50%, -50%)
    -o-transform: translate(-50%, -50%)
    transform: translate(-50%, -50%)
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    ul.nav
      position: relative
      display: flex
      justify-content: space-between
      align-items: center
      width: 5.3rem
      height: .44rem
      margin: .66rem auto 0
      &::after
        content: "|"
        position: absolute
        top: 0
        left: 50%
        font-size: .32rem
        color: #F4F4F4
      li
        font-size: .32rem
        color: #050505
        &.active
          color: #1E81F2
    ul.cc
      width: 5.94rem
      margin: .4rem auto 0
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      li
        position: relative
        width: 5.94rem
        height: .8rem
        line-height: .8rem
        background: url(../../../../assets/icon/ilogin_icon_phone.png) no-repeat .42rem center
        -webkit-background-size: .32rem
        background-size: .32rem
        padding: 0 .88rem
        margin: .32rem auto
        border: .02rem solid #ccc
        -webkit-border-radius: .4rem
        -moz-border-radius: .4rem
        border-radius: .4rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &.active
          border-color: #1E81F2
        &.newpwd, &.tel
          input
            position: relative
            top: -.04rem
            width: 100%
            height: .74rem
            font-size: .24rem
        &:last-child
          background: none
          border: none
          padding: 0
        &:nth-of-type(2)
          background-image: url(../../../../assets/icon/ilogin_icon_password.png)
        input[type=text]
          font-size: .28rem
        input[type=submit],input[type=button]
          width: 5.9rem
          height: .8rem
          background-color: #1E81F2
          font-size: .32rem
          color: #fff
          text-align: center
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
        .send
          position: absolute
          top: 0
          right: .3rem
          font-size: .24rem
          color: #FF6100
          &.disable
            color: #ccc
    .cc.c2
      li:nth-of-type(2)
        background-image: url(../../../../assets/icon/ilogin_icon_valide.png)
    ::-webkit-input-placeholder
      color: #D8D8D8
    .cue
      display: flex
      justify-content: flex-end
      align-items: center
      height: .34rem
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a
        font-size: .28rem
        color: #999
    .thirdlogin
      margin-top: .4rem
      .cc
        display: flex
        justify-content: space-between
        align-items: center
        width: 2.78rem
        margin: .4rem auto 0
        a
          font-size: .28rem
          color: #999
          text-align: center
          img
            display: block
            width: .8rem
            height: .8rem
            margin: 0 auto .2rem
    .close
      position: absolute
      top: .16rem
      right: .16rem
      width: .24rem
      height: .24rem
      line-height: .24rem
      font-size: .4rem
      color: #A3A9B7
      text-align: center
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: 1005
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/share/popup/login/iLogin.vue